import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionItemCategoriesByInstitutionId: IInstitutionItemCategoriesLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID,
            institutionId
        }
    },
    LoadSuccess: IInstitutionItemCategoriesLoadByInstitutionIdSuccessActionCreator = (formData, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS,
            formData,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionItemCategoriesLoadByInstitutionIdFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionItemCategoriesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONITEMCATEGORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionItemCategoriesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONITEMCATEGORIES_FILTER,
            formFilter
        }
    };


export const
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID = "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID",
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS = "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS",
    ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE = "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE",

    ACTION_INSTITUTIONITEMCATEGORIES_CLEAR = "ACTION_INSTITUTIONITEMCATEGORIES_CLEAR",

    ACTION_INSTITUTIONITEMCATEGORIES_FILTER = "ACTION_INSTITUTIONITEMCATEGORIES_FILTER";

export interface IInstitutionItemCategoriesLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID";
    institutionId?: number;
}

export interface IInstitutionItemCategoriesLoadByInstitutionIdActionCreator {
    (institutionId?: number): IInstitutionItemCategoriesLoadByInstitutionIdAction;
}

export interface IInstitutionItemCategoriesLoadByInstitutionIdSuccessAction {
    type: "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_SUCCESS";
    formData: Dtos.InstitutionItemCategory[];
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemCategoriesLoadByInstitutionIdSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemCategory[],
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemCategoriesLoadByInstitutionIdSuccessAction;
}

export interface IInstitutionItemCategoriesLoadByInstitutionIdFailureAction {
    type: "ACTION_INSTITUTIONITEMCATEGORIES_LOAD_BY_INSTITUTIONID_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemCategoriesLoadByInstitutionIdFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemCategoriesLoadByInstitutionIdFailureAction;
}

export interface IInstitutionItemCategoriesClearAction {
    type: "ACTION_INSTITUTIONITEMCATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionItemCategoriesClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionItemCategoriesClearAction;
}

export interface IInstitutionItemCategoriesFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionItemCategoriesFilterAction;
}

export interface IInstitutionItemCategoriesFilterAction {
    type: "ACTION_INSTITUTIONITEMCATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionItemCategoryActions =
    IInstitutionItemCategoriesLoadByInstitutionIdAction |
    IInstitutionItemCategoriesLoadByInstitutionIdSuccessAction |
    IInstitutionItemCategoriesLoadByInstitutionIdFailureAction |
    IInstitutionItemCategoriesClearAction |
    IInstitutionItemCategoriesFilterAction;